import { Button } from '@chakra-ui/button'
import { FunctionComponent, useContext } from 'react'
import { AppContext } from '../../babylonjs/libs/context'
import { IModelDesignData } from '../../babylonjs/type/designType'
import { IModel } from '../../babylonjs/type/modelType'
import { addToCart } from '../utils/cartFunctions'

interface IProps {
  model: IModel
  design: IModelDesignData
}

const AddToCartButton: FunctionComponent<IProps> = ({ model, design }) => {
  const context = useContext(AppContext)

  return (
    <Button
      colorScheme="brand"
      onClick={() => {
        addToCart(model, design, context).then(() => {
          document.location.href = `${process.env.REACT_APP_CART_PAGE_URL}?shopId=${context.shop.id}&cartId=${process.env.REACT_APP_CART_ID}&currency=${context.shop.defaultCurrency}&lang=${context.shop.defaultLanguage}`
        })
      }}
      w="100%"
    >
      Add To Cart
    </Button>
  )
}

export default AddToCartButton
